import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import styles from './AdminSubmissions.module.css';

const AdminSubmissions = () => {
  const { taskId } = useParams();
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSubmissions = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`/api/admin/tasks/${taskId}/uploads`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTeams(response.data.teams || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching submissions:', err);
      if (err.response && err.response.status === 401) {
        navigate('/login');
        return;
      }
      setError('Failed to load submissions. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubmissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  if (isLoading) {
    return <div className={styles.container}>Loading…</div>;
  }

  const renderGrid = (urls) => (
    <div className={styles.grid}>
      {urls.map((url) => (
        <a key={url} href={url} target="_blank" rel="noopener noreferrer" className={styles.thumbLink}>
          <img src={url} alt="" className={styles.thumb} loading="lazy" />
        </a>
      ))}
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <Link to="/admin" className={styles.back}>← Back to Admin</Link>
        <button onClick={fetchSubmissions} className={styles.refresh}>Refresh</button>
      </div>
      <h1>Submissions — {taskId}</h1>

      {error && <p className={styles.error}>{error}</p>}
      {!error && teams.length === 0 && <p>No team submissions yet.</p>}

      {teams.map((team) => (
        <div key={team.name} className={styles.team}>
          <h2 className={styles.teamName}>{team.name}</h2>

          <h3 className={styles.groupHeading}>Edited ({team.edited.length})</h3>
          {team.edited.length === 0 ? (
            <p className={styles.muted}>Not generated yet — the team hasn’t finished all photos.</p>
          ) : (
            renderGrid(team.edited)
          )}

          <h3 className={styles.groupHeading}>Raw uploads ({team.raw.length})</h3>
          {team.raw.length === 0 ? (
            <p className={styles.muted}>No raw photos.</p>
          ) : (
            renderGrid(team.raw)
          )}
        </div>
      ))}
    </div>
  );
};

export default AdminSubmissions;
